<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { SpToast, useTheme } from '@servepod/ui';
import AppShell from '@/components/AppShell.vue';
import { useSession } from '@/stores/session';

const route = useRoute();
const session = useSession();
useTheme();

/** Marketing and auth pages render without the app chrome. */
const chrome = computed(() => route.meta.chrome !== false);

onMounted(() => {
  if (session.status === 'unknown') void session.refresh();
});
</script>

<template>
  <AppShell v-if="chrome">
    <RouterView v-slot="{ Component }">
      <Transition
        mode="out-in"
        enter-active-class="transition-all duration-fast"
        leave-active-class="transition-all duration-fast"
        enter-from-class="opacity-0 translate-y-1"
        leave-to-class="opacity-0"
      >
        <component :is="Component" />
      </Transition>
    </RouterView>
  </AppShell>
  <RouterView v-else />

  <SpToast />
</template>
